import createImagePlugin from '@draft-js-plugins/image';
import ElevatedButton from 'components/ElevatedButton';
import Drawer from 'containers/CompositionFeedback/Drawer';
import RoundButton from 'containers/CompositionFeedback/RoundButton';
import StackedPapers from 'containers/CompositionFeedback/StackedPapers';
import Editor from 'draft-js-plugins-editor';
import {useEffect, useState} from 'react';
import {useMobile} from 'utils/hooks';
import useDraftAsTextHighlighter from 'utils/hooks/useDraftAsTextHighlighter/useDraftAsTextHighlighter';
import styles from './CompositionView.module.scss';

export interface CompositionViewProps {
  compositionTitle: string;
  compositionRaw: string;
  instructions: string;
  annotations?: string;
}

type Tabs = 'Proposta' | 'Anotações';

function CompositionView({
  compositionRaw,
  compositionTitle,
  instructions,
  annotations,
}: CompositionViewProps): JSX.Element {
  const [showMobileDrawer, setShowMobileDrawer] = useState(false);
  const [activeTab, setActiveTab] = useState<Tabs>('Proposta');
  const {isMobile} = useMobile();
  const Sidebar = isMobile ? Drawer : StackedPapers;
  const draftHighlighter = useDraftAsTextHighlighter();

  useEffect(() => {
    draftHighlighter.convertHTMLStringToDraftState(instructions);
  }, [instructions]);

  return (
    <section className={styles.wrapper}>
      <article className={styles.composition}>
        <h1>{compositionTitle}</h1>
        <textarea
          readOnly
          value={compositionRaw}
          className={styles.compositionBody}
        />
      </article>

      <Sidebar open={showMobileDrawer} toggleDrawer={setShowMobileDrawer}>
        <div className={styles.sidebar}>
          {annotations && (
            <menu>
              <li>
                <RoundButton
                  icon="file"
                  label="Proposta"
                  onClick={() => setActiveTab('Proposta')}
                  variant={activeTab === 'Proposta' ? 'primary' : 'secondary'}
                />
              </li>
              <li>
                <RoundButton
                  icon="pencil"
                  label="Anotações"
                  onClick={() => setActiveTab('Anotações')}
                  variant={activeTab === 'Anotações' ? 'primary' : 'secondary'}
                />
              </li>
            </menu>
          )}

          <div className={styles.sidebarContent}>
            <h2>{activeTab}</h2>

            {activeTab === 'Proposta' && (
              <Editor
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                editorState={draftHighlighter.editorState}
                customStyleMap={draftHighlighter.styleMap}
                blockRenderMap={draftHighlighter.blockRenderMap}
                plugins={[createImagePlugin()]}
                onChange={() => {}} // requested prop not used
                readOnly
              />
            )}

            {activeTab === 'Anotações' && (
              <textarea
                className={styles.annotationsContent}
                value={annotations}
                readOnly
              />
            )}
          </div>
        </div>
      </Sidebar>

      {isMobile && (
        <footer>
          <ElevatedButton
            text="Proposta"
            variant="primary"
            onClick={() => setShowMobileDrawer(true)}
          />
        </footer>
      )}
    </section>
  );
}

export default CompositionView;
